// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var MM_editor_history = require("../worker/MM_editor_history.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Static_XML_to_HTML = require("../utils/Static_XML_to_HTML.bs.js");
var Paper = require("@mui/material/Paper").default;
var AppBar = require("@mui/material/AppBar").default;
var Button = require("@mui/material/Button").default;

function MM_cmp_editor_hist(props) {
  var onRestore = props.onRestore;
  var viewOptions = props.viewOptions;
  var onClose = props.onClose;
  var hist = props.hist;
  var editorState = props.editorState;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        if (MM_editor_history.editorHistLength(hist) > 0) {
          return 0;
        } else {
          return -1;
        }
      });
  var setCurIdx = match[1];
  var curIdx = match[0];
  var match$1 = React.useState(function () {
        return MM_editor_history.editorHistGetSnapshotPreview(hist, curIdx, editorState);
      });
  var setCurEditorState = match$1[1];
  var curEditorState = match$1[0];
  var actChangeCurIdx = function (newCurIdx) {
    if (-1 <= newCurIdx && newCurIdx <= (MM_editor_history.editorHistLength(hist) - 1 | 0)) {
      Curry._1(setCurIdx, (function (param) {
              return newCurIdx;
            }));
      return Curry._1(setCurEditorState, (function (param) {
                    return MM_editor_history.editorHistGetSnapshotPreview(hist, newCurIdx, editorState);
                  }));
    }
    
  };
  var prevIsDisabled = curIdx === (MM_editor_history.editorHistLength(hist) - 1 | 0);
  var nextIsDisabled = curIdx === -1;
  var rndButtons = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                style: {
                  padding: "4px"
                },
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onRestore, curIdx);
                      }),
                    variant: "contained",
                    disabled: nextIsDisabled,
                    color: "grey",
                    children: "Restore this"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onClose, undefined);
                      }),
                    children: "Close"
                  }), React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    spacing: 0,
                    children: Caml_option.some(null)
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            actChangeCurIdx(curIdx + 1 | 0);
                          }),
                        disabled: prevIsDisabled,
                        children: "< PREV"
                      }), React.createElement("span", undefined, String(curIdx + 1 | 0)), React.createElement(Button, {
                        onClick: (function (param) {
                            actChangeCurIdx(curIdx - 1 | 0);
                          }),
                        disabled: nextIsDisabled,
                        children: "NEXT >"
                      })));
  };
  var rndMultilineText = function (text, renderer) {
    var style = text.trim() === "" ? ({
          padding: "4px"
        }) : ({
          padding: "0px"
        });
    return React.createElement(Paper, {
                style: style,
                variant: "outlined",
                children: Caml_option.some(text.trim() === "" || Belt_Option.isNone(renderer) ? React.createElement("pre", undefined, text) : Curry._1(Belt_Option.getExn(renderer), text))
              });
  };
  var rndDescr = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "12px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Description"), rndMultilineText(editorState.descr, (function (str) {
                      return React.createElement(Static_XML_to_HTML.make, {
                                  xmlStr: str
                                });
                    })));
  };
  var rndVars = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Variables"), rndMultilineText(editorState.varsText, undefined));
  };
  var rndDisj = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Disjoints"), rndMultilineText(editorState.disjText, undefined));
  };
  var rndStmts = function (editorState) {
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(editorState.stmts.map(function (__x) {
                          return React.createElement(MM_cmp_user_stmt.make, {
                                      modalRef: modalRef,
                                      settingsVer: editorState.settingsV,
                                      settings: editorState.settings,
                                      preCtxVer: editorState.preCtxV,
                                      varsText: editorState.varsText,
                                      wrkCtx: editorState.wrkCtx,
                                      frms: editorState.frms,
                                      parenCnt: editorState.parenCnt,
                                      syntaxTypes: editorState.syntaxTypes,
                                      parensMap: editorState.parensMap,
                                      typeColors: editorState.typeColors,
                                      preCtxColors: editorState.preCtxColors,
                                      wrkCtxColors: editorState.wrkCtxColors,
                                      editStmtsByLeftClick: editorState.settings.editStmtsByLeftClick,
                                      longClickEnabled: editorState.settings.longClickEnabled,
                                      longClickDelayMs: editorState.settings.longClickDelayMs,
                                      defaultStmtType: editorState.settings.defaultStmtType,
                                      showVisByDefault: editorState.settings.showVisByDefault,
                                      viewOptions: {
                                        showCheckbox: false,
                                        showLabel: viewOptions.showLabel,
                                        showType: viewOptions.showType,
                                        showJstf: viewOptions.showJstf,
                                        inlineMode: viewOptions.inlineMode,
                                        smallBtns: viewOptions.smallBtns
                                      },
                                      readOnly: true,
                                      parenAc: false,
                                      toggleParenAc: (function (param) {
                                          
                                        }),
                                      stmt: __x,
                                      onLabelEditRequested: (function (param) {
                                          
                                        }),
                                      onLabelEditDone: (function (param) {
                                          
                                        }),
                                      onLabelEditCancel: (function (param) {
                                          
                                        }),
                                      onTypEditRequested: (function (param) {
                                          
                                        }),
                                      onTypEditDone: (function (param, param$1) {
                                          
                                        }),
                                      onContEditRequested: (function (param) {
                                          
                                        }),
                                      onContEditDone: (function (param) {
                                          
                                        }),
                                      onContEditCancel: (function (param) {
                                          
                                        }),
                                      onSyntaxTreeUpdatedWithoutContentChange: (function (newStmtCont) {
                                          var stmtId = __x.id;
                                          var update = function (__x) {
                                            return MM_wrk_editor.setStmtCont(__x, stmtId, newStmtCont);
                                          };
                                          Curry._1(setCurEditorState, (function (stRes) {
                                                  if (stRes.TAG === /* Ok */0) {
                                                    return {
                                                            TAG: /* Ok */0,
                                                            _0: Curry._1(update, stRes._0)
                                                          };
                                                  } else {
                                                    return stRes;
                                                  }
                                                }));
                                        }),
                                      onJstfEditRequested: (function (param) {
                                          
                                        }),
                                      onJstfEditDone: (function (param) {
                                          
                                        }),
                                      onJstfEditCancel: (function (param) {
                                          
                                        }),
                                      checkboxDisabled: true,
                                      checkboxChecked: false,
                                      checkboxOnChange: (function (param) {
                                          
                                        }),
                                      onGenerateProof: (function (param) {
                                          
                                        }),
                                      onDebug: (function (param) {
                                          
                                        }),
                                      addStmtAbove: (function (param) {
                                          
                                        }),
                                      addStmtBelow: (function (param) {
                                          
                                        }),
                                      setShowTabs: (function (param) {
                                          
                                        }),
                                      openFrameExplorer: (function (param) {
                                          
                                        })
                                    });
                        }))
              });
  };
  var rndEditorState = function (param) {
    if (curEditorState.TAG !== /* Ok */0) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, "Error reading editor history: " + curEditorState._0 + "");
    }
    var editorState = curEditorState._0;
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, rndDescr(editorState), rndVars(editorState), rndDisj(editorState), rndStmts(editorState));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(null)
            }, React.createElement(AppBar, {
                  position: "sticky",
                  color: "white",
                  children: rndButtons(undefined)
                }), rndEditorState(undefined));
}

var make = MM_cmp_editor_hist;

exports.make = make;
/* react Not a pure module */
